module.exports = __webpack_public_path__ + "media/images/country_flags/sj-1dfdc0740e3f052e85a5988880139d5f.png";